import React from 'react';

import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';


import { useQuery } from "react-query";

// see : https://tanstack.com/query/latest/docs/react/guides/paginated-queries
// see:  https://tanstack.com/query/v3/docs/react/guides/paginated-queries


import { fetchUtilisateursAdministration } from 'utils/ts-queries';
import { ApiDepot } from 'types/apiReturns';


import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import TablePagination from '@mui/material/TablePagination';


import TriStateFilter from 'components/Shared/TriStateFilter';
import DepotGestionAutocomplete from 'components/Shared/DepotGestionAutocomplete';

import MultipleItemsBadgeAndPopover from 'components/Shared/MultipleItemsBadgeAndPopover';


// import { Profils } from 'constants.js';
import { Profils } from 'ts-constants';


const AdministrationUtilisateursTable = () => {

    const [page, setPage] = React.useState(0);
    const [nbParPage, setNbParPage] = React.useState<number>(10);

    const [filtreActif, setFiltreActif] = React.useState<boolean | null>(true);
    const [filtreAnonyme, setFiltreAnonyme] = React.useState<boolean | null>(null);

    const [filtreCodePO, setFiltreCodePO] = React.useState('');
    const [filtreCodeDepot, setFiltreCodeDepot] = React.useState('');
    const [filtreDenomination, setFiltreDenomination] = React.useState('');

    const [filtreProfil, setFiltreProfil] = React.useState('');

    const [filtreCodeDepotMultiples, setFiltreCodeDepotMultiples] = React.useState<boolean | null>(null);

    const { isLoading, isError, data } =
        useQuery({
            queryKey: [
                'utilisateursTable',
                page,
                nbParPage,
                filtreActif,
                filtreAnonyme,
                filtreCodePO,
                filtreProfil,
                filtreCodeDepot,
                filtreDenomination,
                filtreCodeDepotMultiples
            ],
            queryFn: () => fetchUtilisateursAdministration({
                page,
                nbParPage,
                filtreActif,
                filtreAnonyme,
                filtreCodePO,
                filtreProfil,
                filtreCodeDepot,
                filtreDenomination,
                filtreCodeDepotMultiples
            }),
            keepPreviousData: true,
        })




    const handleChangePage = (_event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
        setPage(newPage);
    };


    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNbParPage(+event.target.value);
        setPage(0);
    };


    const handleChangeFiltreCodeDepotMultiples = (value: boolean | null) => {
        setFiltreCodeDepotMultiples(value);
    };

    

    React.useEffect(() => {
            setPage(0);
        },
        [filtreActif, filtreAnonyme, filtreCodePO, filtreProfil, filtreCodeDepot, filtreDenomination]
    );



    return (
        <>
            <Typography gutterBottom variant="h5">
                Visualisation des utilisateurs
            </Typography>


            {isLoading ? (
                <div>Chargement...</div>
            ) : isError ? (
                <div>Erreur: Échec du chargement</div>
            ) : (
                <span></span>
            )}

            <Paper>

                {data !== undefined ? (
                    <TableContainer sx={{ maxHeight: '100%' }}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ backgroundColor: 'lightslategrey', width: '20px' }}>Id</TableCell>
                                    <TableCell sx={{ backgroundColor: 'lightslategrey', width: '30px' }}>CodePO</TableCell>

                                    <TableCell sx={{ backgroundColor: 'lightslategrey' }}>Nom (Prénom)</TableCell>
                                    <TableCell sx={{ backgroundColor: 'lightslategrey' }}>Login</TableCell>

                                    <TableCell sx={{ backgroundColor: 'lightslategrey' }}>Dépot</TableCell>
                                    <TableCell sx={{ backgroundColor: 'lightslategrey' }}>Dépots autorisés</TableCell>
                                    <TableCell sx={{ backgroundColor: 'lightslategrey' }}>Agence</TableCell>

                                    <TableCell sx={{ backgroundColor: 'lightslategrey', width: '30px' }}>Profil</TableCell>

                                    <TableCell sx={{ backgroundColor: 'lightslategrey', width: '100px' }}>Anonyme</TableCell>
                                    <TableCell sx={{ backgroundColor: 'lightslategrey', width: '100px' }}>Actif</TableCell>



                                </TableRow>
                                <TableRow>
                                    <TableCell></TableCell>
                                    <TableCell>
                                        <TextField
                                            value={filtreCodePO}
                                            onChange={e => { setFiltreCodePO(e.target.value) }}
                                        >
                                        </TextField>
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            value={filtreDenomination}
                                            onChange={e => { setFiltreDenomination(e.target.value) }}
                                        >
                                        </TextField>
                                    </TableCell>
                                    <TableCell></TableCell>

                                    <TableCell>
                                        <DepotGestionAutocomplete
                                            value={filtreCodeDepot}
                                            onChange={(_e: any, c: string, _d: any) => { setFiltreCodeDepot(c); }}
                                            withEmpty
                                        />
                                        
                                    </TableCell>
                                    <TableCell>
                                        <TriStateFilter
                                            value={filtreCodeDepotMultiples}
                                            onChange={handleChangeFiltreCodeDepotMultiples}
                                            labels={['n/a', 'simple', 'multiple']}
                                            maxWidth={'128px'}
                                        />
                                        
                                    </TableCell>

                                    <TableCell>
                                    </TableCell>

                                    <TableCell>

                                        <TextField
                                            select
                                            value={filtreProfil}
                                            onChange={e => { setFiltreProfil(e.target.value) }}
                                        >

                                            <MenuItem key={-1} value={''}>
                                                {""}
                                            </MenuItem>
                                            {Object.entries(Profils).map((profil, index) => (
                                                <MenuItem key={index} value={profil[1]}>
                                                    {profil[1]}
                                                </MenuItem>
                                            ))}

                                        </TextField>


                                    </TableCell>

                                    <TableCell>
                                        <TriStateFilter
                                            value={filtreAnonyme}
                                            onChange={(newValue: boolean | null) => { setFiltreAnonyme(newValue) }}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <TriStateFilter
                                            value={filtreActif}
                                            onChange={(newValue: boolean | null) => { setFiltreActif(newValue) }}
                                        />
                                    </TableCell>

                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {data.utilisateurs
                                    .map((utilisateur) => {

                                        let depots = '';
                                        if (utilisateur.depots && utilisateur.depots.length > 0) {
                                            depots = `${utilisateur.depots[0]!.code} - ${utilisateur.depots[0]!.nom}`;
                                            if (filtreCodeDepot) {
                                                const principal = utilisateur.depots.find(x => x.code === filtreCodeDepot);
                                                depots = principal ? `${principal.code} - ${principal.nom}` : '';
                                            }
                                        }

                                        return (
                                            <TableRow hover key={`${utilisateur.id}`}>
                                                <TableCell>
                                                    <Link
                                                        to={`/administration/utilisateurs/${utilisateur.id}`}
                                                        underline="hover"
                                                        component={RouterLink}
                                                        sx={{ fontWeight: 'bold' }}
                                                    >
                                                        {utilisateur.id}
                                                    </Link>
                                                </TableCell>
                                                <TableCell>{utilisateur.codePO}</TableCell>

                                                <TableCell>{`${utilisateur.nom}${utilisateur.prenom ? ' ' + utilisateur.prenom : ''}`}</TableCell>
                                                <TableCell>{utilisateur.login}</TableCell>

                                                <TableCell>{utilisateur.depot ? utilisateur.depot.code + ' - ' + utilisateur.depot.nom : ''}</TableCell>
                                                <TableCell>                                                
                                                    <MultipleItemsBadgeAndPopover 
                                                        label={depots}
                                                        title={`Dépots autorisés pour ${utilisateur.nom}`}
                                                        items={utilisateur.depots}
                                                        display={(x) => {
                                                            const depot = x as ApiDepot;
                                                            return (`${depot.code} - ${depot.nom}`);
                                                        }}
                                                        badge={true}
                                                    />
                                                </TableCell>
                                                <TableCell>{utilisateur.agence ? utilisateur.agence.code + ' - ' + utilisateur.agence.libelle : ''}</TableCell>

                                                <TableCell>{utilisateur.codePoste}</TableCell>
                                                <TableCell>{utilisateur.anonyme ? 'anonyme' : ''}</TableCell>
                                                <TableCell>{utilisateur.actif ? 'oui' : 'NON'}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>

                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            count={data.nbFiltres}
                            rowsPerPage={nbParPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableContainer>
                ) : <span>...</span>
                }

            </Paper>


        </>

        );

};


export default AdministrationUtilisateursTable;
